export default __webpack_public_path__ + "static/media/copy-code-blue.740d7ede.svg";